import { UserRole } from '@paragon/contract-library';
import { userService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { AsyncThunkActionReturn } from './thunkActions';

export function generatePermanentLink(
  stationGuid: string,
): AsyncThunkActionReturn<{ readonly token: string; readonly guid: string } | null> {
  return async function generatePermanentLinkThunkAction(dispatch) {
    const spinnerId = dispatch(addSpinnerMessage('Generating permanent link...'));

    try {
      const roleSet = { role: UserRole.Assembler, whitelist: [], blacklist: [] };
      const customClaims = { createdForUseAtStation: stationGuid };

      return await userService.tokens.generateStandaloneToken(roleSet, customClaims);
    } catch (error) {
      console.error(error);
      dispatch(enqueueError('Unable to generate permanent link at this time.'));

      return null;
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }
  };
}
